if (!customElements.get('image-compare')) {
  class ImageCompare extends HTMLElement {
    constructor() {
      super();
      this.handle = this.querySelector('.before-after-gallery__handle');
      this.dragging = false;

      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);

      this.addEventListener('pointerdown', this.onPointerDown);
      window.addEventListener('pointermove', this.onPointerMove);
      window.addEventListener('pointerup', this.onPointerUp);

      if (this.handle) {
        this.handle.addEventListener('keydown', this.onKeyDown);
      }
    }

    onPointerDown(event) {
      event.preventDefault();
      this.dragging = true;
      this.updateFromEvent(event);
    }

    onPointerMove(event) {
      if (!this.dragging) return;
      this.updateFromEvent(event);
    }

    onPointerUp() {
      this.dragging = false;
    }

    onKeyDown(event) {
      const current = parseFloat(this.style.getPropertyValue('--position')) || 50;
      if (event.key === 'ArrowLeft') {
        this.setPosition(current - 5);
      } else if (event.key === 'ArrowRight') {
        this.setPosition(current + 5);
      } else {
        return;
      }
      event.preventDefault();
    }

    updateFromEvent(event) {
      const rect = this.getBoundingClientRect();
      const percent = ((event.clientX - rect.left) / rect.width) * 100;
      this.setPosition(percent);
    }

    setPosition(percent) {
      const clamped = Math.min(100, Math.max(0, percent));
      this.style.setProperty('--position', clamped + '%');
      if (this.handle) this.handle.setAttribute('aria-valuenow', Math.round(clamped));
    }
  }

  customElements.define('image-compare', ImageCompare);
}

if (!customElements.get('before-after-gallery')) {
  class BeforeAfterGallery extends HTMLElement {
    constructor() {
      super();
      this.mainSlider = this.querySelector('.before-after-gallery__slider');
      this.slides = Array.from(this.querySelectorAll('.before-after-gallery__slide'));
      this.thumbButtons = Array.from(this.querySelectorAll('.before-after-gallery__thumb'));
      this.thumbsSlider = this.querySelector('.before-after-gallery__thumbs');
      // Solo los paneles por bloque cambian; el panel de contenido único queda siempre visible.
      this.panels = Array.from(this.querySelectorAll('.before-after-gallery__panel[data-block-id]'));

      if (!this.mainSlider || !this.slides.length) return;

      this.scrollTimeout = null;

      this.thumbButtons.forEach((button) => {
        button.addEventListener('click', this.onThumbClick.bind(this));
      });

      this.mainSlider.addEventListener('scroll', this.onMainScroll.bind(this));
    }

    onThumbClick(event) {
      const blockId = event.currentTarget.dataset.blockId;
      const targetSlide = this.slides.find((slide) => slide.dataset.blockId === blockId);
      if (!targetSlide) return;

      this.mainSlider.scrollTo({ left: targetSlide.offsetLeft, behavior: 'smooth' });
      this.setActiveBlock(blockId);
    }

    onMainScroll() {
      window.clearTimeout(this.scrollTimeout);
      this.scrollTimeout = window.setTimeout(() => {
        const nearest = this.slides.reduce((closest, slide) => {
          const distance = Math.abs(slide.offsetLeft - this.mainSlider.scrollLeft);
          return distance < closest.distance ? { slide, distance } : closest;
        }, { slide: this.slides[0], distance: Infinity }).slide;

        this.setActiveBlock(nearest.dataset.blockId);
      }, 100);
    }

    setActiveBlock(blockId) {
      const activeButton = this.thumbButtons.find((button) => button.dataset.blockId === blockId);
      this.thumbButtons.forEach((button) => button.classList.toggle('is-active', button === activeButton));

      if (activeButton && this.thumbsSlider) {
        const item = activeButton.closest('.before-after-gallery__thumb-item');
        if (item) this.thumbsSlider.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
      }

      this.panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.blockId === blockId));
    }
  }

  customElements.define('before-after-gallery', BeforeAfterGallery);
}
